export const AVATAR_BUTTON_TARGET_ID = 'avatar-button'
